export default __webpack_public_path__ + "static/media/14g28mma.492d053b.jpeg";